<!--
 - List component view
 - Component lists all order types (work, lookahead etc.)
 -
 - @version
 - 4.71.0 OAUI-693 Tidy and remove duplicated code
 - 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 - 4.70.0 OAUI-678 Build "Driver Assignment" UI
 - 4.70.0 OAUI-677 Add total price column on work orders
 - 4.69.0 OAUI-677 Add total price column on work orders
 - 4.67.0 OAUI-660 The order-admin-ui redirects to order-admin-ui root before directing to the target URL
 - 4.67.0 OAUI-667 Add item progress to Work Orders
 - 4.64.0 OAUI-661 Fix the faulty labels in order-admin-ui-v2
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.59.0 OAUI-640 Add adjustments without fulfillment groups
 - 4.59.0 OAUI-618 Update the checkbox column to toggle on/off based on permissions
 - 4.54.0 OAUI-611 Increase readability for special instructions on tag fields
 - 4.48.0 OAUI-590 Enable column sorting for work orders and lookahead orders
 - 4.46.0 OAUI-577 Updating item shipping status shows "[object Object]"
 - 4.46.0 OAUI-572 Remove references to order-admin-api
 - 4.46.0 OAUI-575 Ecommerce orders on deployments with job override 'off' have display issues
 - 4.42.0 OAUI-555 Add dropdown to download attachments in work orders v2
 - 4.41.0 OAUI-551 Add styling for different production statuses in work orders V2
 - 4.40.0 OAUI-547 Access check for updating delivery date on Work Orders is using the wrong method
 - 4.38.0 OAUI-537 Toggle table columns on order list table
 - 4.38.0 OAUI-535 Style order rows based on order status
 - 4.38.0 OAUI-536 Job text is overlapping on smaller screens
 - 4.37.0 OAUI-527 Slowdowns in order modals
 - 4.37.0 OAUI-532 Add missing filters for v2 orders list
 - 4.37.0 OAUI-528 Sometime the page title on the list orders page doesn't translate
 - 4.37.0 OAUI-531 Click on tracker order fulfillment group should go to order in tracker-ui
 - 4.36.0 OAUI-517 Work Orders V2: add UI for adding a lookahead order
 - 4.36.0 OAUI-521 Add support to only show new reports on details/work orders V2
 - 4.36.0 OAUI-523 Refactor order details view for Lookahead orders
 - 4.36.0 OAUI-518 Add order reports and exports
 - 4.36.0 OAUI-502 Edit order details
 - 4.35.0 OAUI-498 View Order Fittings and Products by Fulfillment Group
 - 4.35.0 OAUI-496 Add header and missing fields
 - 4.35.0 OAUI-494 Update Ecommerce Job Overrides
 - 4.34.0 OAUI-491 Update order dates
 - 4.34.0 OAUI-489 Update multiple order statuses based on selection
 - 4.34.0 OAUI-488 Update fulfillment and shipping statuses
 - 4.34.0 OAUI-487 Update order status
 - 4.34.0 OAUI-479 Optimize the list orders page to avoid overloaded SCSS files
 - 4.33.0 OAUI-473 Toggle Empty Fulfillment Groups based on Setting
 - 4.33.0 OAUI-472 Add internal angular routing for view/manage order details
 - 4.33.0 OAUI-471 Add report/export links for orders to Work Orders V2
 - 4.33.0 OAUI-462 Display order fulfillment groups
 - 4.33.0 OAUI-468 Remove duplicate calls for constants and hostConfiguration
 - 4.33.0 OAUI-461 Add checks and display for missing job, company and user data
 - 4.31.0 OAUI-460 Disable and hide count down timer on Work Orders listing v2
 - 4.31.0 OAUI-455 Add basic table to display orders
 - 4.31.0 OAUI-453 Set up basic list settings, filters and layout
 - 4.31.0 OAUI-452 Set up basic list orders routing
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022-2024 Build Centrix
 -->
<form #ordersListForm="ngForm" class="bcx-orders">
  <!--Header-->
  <div class="order-header row mb-1">
    <div class="w-100" *ngIf="!wdOrdersV2Service.isLoadingOrders.value">
      <app-orders-list-header-component
        [orderType]="orderType"
        [pageTitle]="orderTitle"
        [pageSubtitle]="orderSubtitle"
      ></app-orders-list-header-component>
    </div>
  </div>

  <!--Content-->
  <div
    class="order-content row"
    [ngClass]="{ 'loaded': wdOrdersV2Service.isReloadingOrders.value === false,
                      'loading': wdOrdersV2Service.isReloadingOrders.value === true}"
  >
    <div class="col-sm-12">
      <!--Page Loader-->
      <div
        class="bcx-loader-container"
        [hidden]="wdOrdersV2Service.isLoadingOrders.value === false"
      >
        <bc-atoms-loader
          [title]="'actions.loadingType'|translate: {type:('order.title.plural'|translate)}"
          [active]="true"
          [fullscreen]="false"
        ></bc-atoms-loader>
      </div>

      <!--Order Content-->
      <div
        class="bcx-order-container"
        [hidden]="wdOrdersV2Service.isLoadingOrders.value === true"
      >
        <div class="row">
          <div class="col-sm-12">
            <!--Orders Table-->
            <bc-templates-table-container
              class="orders-table"
              [dataSource]="orderListDataSource"
              [headers]="wdOrdersService.orderListColumns"
              [isLoading]="isLoading"
              [paginationPageSize]="wdOrdersV2Service.orderViewSettings.pageSize"
              [customColSpan]="wdOrdersService.orderListColumns.length"
              matSort
            >
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell class="select-column" *matHeaderCellDef>
                  <!--Select All Checkbox-->
                  <mat-checkbox
                    (change)="$event ? toggleAllCheckboxes() : null"
                    disableRipple="true"
                    [checked]="wdOrdersService.orderListSelections.hasValue() && isAllSelected()"
                    [indeterminate]="wdOrdersService.orderListSelections.hasValue() && !isAllSelected()"
                    [aria-label]="setCheckboxLabel()"
                    color="primary"
                  >
                  </mat-checkbox>
                </th>
                <td
                  mat-cell
                  class="select-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  *matCellDef="let element"
                >
                  <!--Select Row Checkbox-->
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? wdOrdersService.orderListSelections.toggle(element) : null"
                    disableRipple="true"
                    [checked]="wdOrdersService.orderListSelections.isSelected(element)"
                    [aria-label]="setCheckboxLabel(element)"
                    color="primary"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>

              <!--Order Number-->
              <!--Also includes special instructions & attachments/adjustments count-->
              <ng-container matColumnDef="number">
                <th
                  class="order-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.number.description'|translate}}"
                >
                  {{'order.details.number.title'|translate}}
                </th>
                <td
                  class="order-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.number.title'|translate}}"
                >
                  <div class="details-label">
                    <!--Order Number-->
                    <a
                      [routerLink]="['/orders/manage/', element.index]"
                      target="_blank"
                    >
                      <bc-atoms-button
                        id="orderNumber"
                        label="{{element.number}}"
                        title="{{element.number}}"
                        type="link"
                        icon="view"
                        display="block"
                      >
                      </bc-atoms-button>
                    </a>
                  </div>
                  <div
                    class="order-icons text-center"
                    [ngbPopover]="popContent"
                    placement="right"
                    triggers="mouseenter:mouseleave:click"
                    #orderContentPopover="ngbPopover"
                    (click)="toggleOrderContentPopover(orderContentPopover, element)"
                    (mouseenter)="toggleOrderContentPopover(orderContentPopover, element)"
                    (mouseleave)="toggleOrderContentPopover(orderContentPopover, element)"
                    [ngClass]="{'inactive':element.specialInstructions === 'n/a' &&
                                                    element.meta.attachments.count === 0 &&
                                                    element.meta.adjustments.count === 0 }"
                  >
                    <!--Special Instructions-->
                    <div
                      class="order-icon"
                      [ngClass]="{'inactive':element.specialInstructions === 'n/a'}"
                    >
                      <bc-atoms-icon type="information"></bc-atoms-icon>
                    </div>

                    <!--Attachments-->
                    <div
                      class="order-icon"
                      [ngClass]="{'inactive':element.meta.attachments.count === 0}"
                    >
                      <bc-atoms-icon
                        type="attachment"
                        [matMenuTriggerFor]="menu"
                      >
                      </bc-atoms-icon>

                      <mat-menu class="dropdown-mat-menu" #menu="matMenu">
                        <!--Drop down to download attachments-->
                        <div class="dropdown-title">
                          {{'exports.attachments.title'|translate}}
                        </div>
                        <div
                          *ngFor="let attachElem of element.attachments; let i = index"
                        >
                          <a [href]="attachElem.url">
                            <button class="attachment-item" mat-menu-item>
                              <label
                                >{{i+1}}. {{attachElem.originalFileName}}</label
                              >
                            </button>
                          </a>
                        </div>
                      </mat-menu>
                    </div>

                    <!--Adjustments-->
                    <div
                      class="order-icon"
                      [ngClass]="{'inactive':element.meta.adjustments.count === 0}"
                    >
                      <bc-atoms-icon type="adjustment"></bc-atoms-icon>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Lookahead Details -->
              <ng-container matColumnDef="lookahead">
                <th
                  class="lookahead-column"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.types.lookahead.description'|translate}}"
                >
                  {{'order.types.lookahead.title'|translate}}
                </th>
                <td
                  class="lookahead-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.types.lookahead.title'|translate}}"
                >
                  <!--Spacer-->
                  <div class="details-label">&nbsp;</div>
                  <!--Lookahead Label-->
                  <div class="main-label">{{element.tag}}</div>
                  <!--Lookahead Description-->
                  <div class="details-label">
                    {{element.specialInstructions}}
                  </div>
                </td>
              </ng-container>

              <!--Job-->
              <ng-container matColumnDef="job">
                <th
                  class="job-column"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.list.job.description'|translate}}"
                >
                  {{'order.list.job.title'|translate}}
                </th>
                <td
                  class="job-column editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.list.job.title'|translate}}"
                >
                  <!--Job Number-->
                  <div class="job-number details-label">
                    <span *ngIf="canEditEcomJobOverride(element)">
                      <a
                        target="_blank"
                        [ngbPopover]="popContentOverride"
                        [autoClose]="'outside'"
                        placement="bottom"
                        triggers="manual"
                        #orderOverridePopover="ngbPopover"
                        (click)="toggleOrderOverridePopover(orderOverridePopover, element, 'number', 'Number')"
                      >
                        <bc-atoms-button
                          [label]="element.job?.override?.number"
                          [title]="element.job?.override?.number"
                          type="link"
                          icon="edit"
                          [loading]="element.job?.override['isUpdatingNumber']"
                        >
                        </bc-atoms-button>
                      </a>
                    </span>
                    <span *ngIf="canViewReadOnlyJob(element)">
                      <span *ngIf="element.job?.number">
                        {{element.job?.number}}
                      </span>
                      <span *ngIf="!element.job?.number" class="text-danger"
                        >{{'errors.unknown'|translate}}</span
                      >
                    </span>
                  </div>
                  <!--Job Name-->
                  <div class="job-name">
                    <div
                      class="main-label"
                      *ngIf="canEditEcomJobOverride(element)"
                    >
                      <a
                        target="_blank"
                        [ngbPopover]="popContentOverride"
                        [autoClose]="'outside'"
                        placement="bottom"
                        triggers="manual"
                        #orderOverridePopover="ngbPopover"
                        (click)="toggleOrderOverridePopover(orderOverridePopover, element, 'name', 'Name')"
                      >
                        <bc-atoms-button
                          [label]="element.job?.override?.name"
                          [title]="element.job?.override?.name"
                          type="link"
                          icon="edit"
                          icon="edit"
                          [loading]="element.job?.override['isUpdatingName']"
                        >
                        </bc-atoms-button>
                      </a>
                    </div>
                    <div class="main-label" *ngIf="canViewReadOnlyJob(element)">
                      <span *ngIf="element.job?.name">
                        {{element.job?.name}}
                      </span>
                      <span *ngIf="!element.job?.name" class="text-danger">
                        {{'errors.missingTypeData'|translate: {
                        type:('order.title.singular'|translate) } }}
                      </span>
                    </div>
                  </div>
                  <!--Job Phase-->
                  <div class="phase-label details-label">
                    <span *ngIf="element.job?.phase"
                      >{{element.job?.phase?.label}}</span
                    >
                    <span *ngIf="!element.job?.phase">
                      <span
                        class="text-uppercase"
                        *ngIf="element.type === 'ecommerce'"
                      >
                        {{'order.types.ecommerce.description'|translate}}
                      </span>
                    </span>
                  </div>
                </td>
              </ng-container>

              <!-- Organization, User, User Group -->
              <ng-container matColumnDef="user">
                <th
                  class="user-column"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.list.user.orderedFor.description'|translate}}"
                >
                  {{'order.list.user.orderedFor.title'|translate}}
                </th>
                <td
                  class="user-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.list.user.orderedFor.title'|translate}}"
                >
                  <div class="company-name details-label">
                    <span *ngIf="element.orderedFor?.company?.label">
                      {{element.orderedFor?.company?.label}}
                    </span>
                    <span
                      *ngIf="!element.orderedFor?.company?.label"
                      class="text-danger"
                    >
                      {{'errors.unknown'|translate}}
                    </span>
                  </div>
                  <div class="user-name main-label">
                    <span
                      *ngIf="element.orderedFor?.name?.first || element.orderedFor?.name?.last"
                    >
                      {{element.orderedFor?.name?.last}},
                      {{element.orderedFor?.name?.first}}
                    </span>
                    <span
                      *ngIf="!(element.orderedFor?.name?.first || element.orderedFor?.name?.last)"
                      class="text-danger"
                    >
                      {{'errors.missingTypeData'|translate: {
                      type:('order.title.singular'|translate) } }}
                    </span>
                  </div>
                  <div class="details-label">
                    <div *ngIf="element.userGroup">
                      <div class="user-group-label">
                        {{element.userGroup?.label}}
                      </div>
                    </div>
                    <div *ngIf="!element.userGroup">
                      <div class="user-group-label text-info">E-commerce</div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- PO Number -->
              <ng-container matColumnDef="poNumber">
                <th
                  class="po-number-column"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.poNumber.description'|translate}}"
                >
                  {{'order.details.poNumber.title'|translate}}
                </th>
                <td
                  class="details-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.poNumber.title'|translate}}"
                >
                  <!--Spacer-->
                  <div class="details-label">&nbsp;</div>
                  <!--PO Number-->
                  <div class="main-label">{{element.poNumber}}</div>
                  <!--Spacer-->
                  <div class="details-label">&nbsp;</div>
                </td>
              </ng-container>

              <!-- Tag -->
              <ng-container matColumnDef="tag">
                <th
                  class="tag-column"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.tag.description'|translate}}"
                >
                  {{'order.details.tag.title'|translate}}
                </th>
                <td
                  class="details-column bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.tag.title'|translate}}"
                >
                  <!--Tag-->
                  <div class="main-label tag">{{element.tag}}</div>
                </td>
              </ng-container>

              <!--Fulfillment Groups-->
              <ng-container matColumnDef="groups">
                <th
                  class="fg-column text-center editable-cell"
                  [ngClass]="{ 'text-center': this.wdOrdersV2Service.orderViewSettings.groups.fulfillment.showEmpty,
                                   'text-right': !this.wdOrdersV2Service.orderViewSettings.groups.fulfillment.showEmpty }"
                  [ngStyle]="{'width': this.wdOrdersService.columnWidthFgs + '%' }"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.fulfillment.description'|translate}}"
                >
                  {{'order.fulfillment.title'|translate}}
                </th>
                <td
                  class="fg-column text-right editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  [ngStyle]="{'width': this.wdOrdersService.columnWidthFgs + '%' }"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.fulfillment.title'|translate}}"
                >
                  <!--Loop all fulfillment groups-->
                  <div
                    class="d-inline-block"
                    *ngFor="let group of wdOrdersV2Service.orderFilters.value.fulfillmentGroups"
                  >
                    <!--Check if group should be displayed-->
                    <div
                      class="fg-groups text-center"
                      [title]="group.label"
                      *ngIf="showFulfillmentGroup(group, element.fulfillment?.groups)"
                    >
                      <!--Group code-->
                      <div class="details-label">{{group.code}}</div>
                      <!--Loop order fulfillment groups-->
                      <div
                        *ngFor="let orderGroup of element.fulfillment?.groups"
                      >
                        <!--Check if group should be displayed-->
                        <div
                          *ngIf="isMatchingFulfillmentGroup(group, orderGroup)"
                        >
                          <div
                            class="status-value fg-icon inactive"
                            *ngIf="!orderGroup.status?.type"
                          >
                            <bc-atoms-icon
                              type="cancel"
                              [title]="orderGroup.status?.label"
                            ></bc-atoms-icon>
                          </div>
                          <div
                            class="status-value fg-icon active"
                            *ngIf="orderGroup.status?.type"
                          >
                            <!--Icon Only-->
                            <div
                              *ngIf="!wdEnvironmentService.permissions.canChangeFulfillmentGroupStatus"
                            >
                              <bc-atoms-icon
                                [type]="orderGroup.status?.type"
                                [title]="orderGroup.status?.label"
                              ></bc-atoms-icon>
                            </div>
                            <!--Editable Dropdown-->
                            <div
                              *ngIf="wdEnvironmentService.permissions.canChangeFulfillmentGroupStatus"
                            >
                              <!--Fulfillment Groups-->
                              <div *ngIf="orderGroup.module !== 'tracker'">
                                <bc-atoms-dropdown
                                  labelKey="label"
                                  iconKey="type"
                                  size="small"
                                  [iconOnly]="true"
                                  [title]="orderGroup.status?.label"
                                  [requireSelection]="true"
                                  [loading]="orderGroup.isUpdatingOrder"
                                  [options]="wdOrdersV2Service.orderFilters.value.productionStatuses"
                                  [(model)]="orderGroup.status"
                                  (modelChange)="updateFulfillmentGroupStatus(element, orderGroup)"
                                >
                                </bc-atoms-dropdown>
                              </div>
                              <!--Tracker Groups-->
                              <div *ngIf="orderGroup.module === 'tracker'">
                                <a
                                  [href]="element.resources.toolTrackerOrderUrl"
                                  target="_blank"
                                >
                                  <!--@todo Once vertical slicing is removed we can replace the href with angular navigation-->
                                  <bc-atoms-button
                                    size="small"
                                    [title]="orderGroup.status?.label"
                                    [icon]="orderGroup.status.type"
                                    [iconOnly]="true"
                                    [loading]="orderGroup.isUpdatingOrder"
                                    [disabled]="orderGroup.isUpdatingOrder"
                                  >
                                  </bc-atoms-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Display alternate text if no matching fulfillment group -->
                      <div
                        *ngIf="!hasMatchingFulfillmentGroup(group, element.fulfillment?.groups)"
                        class="status-value fg-icon inactive"
                      >
                        <bc-atoms-icon type="cancel"></bc-atoms-icon>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Ordered-->
              <ng-container matColumnDef="ordered">
                <th
                  class="date-status-column text-center editable-cell"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.ordered.description'|translate}}"
                >
                  {{'order.details.ordered.title'|translate}}
                </th>
                <td
                  class="date-status-column editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.ordered.title'|translate}}"
                >
                  <!--Date Only-->
                  <div class="details-label editable-content text-center">
                    <span>
                      {{element.ordered?.date|date:wdEnvironmentService.datePipeFormat}}
                    </span>
                  </div>
                  <!--Order Status-->
                  <div class="status-value fg-icon active">
                    <!--Icon Only-->
                    <div
                      *ngIf="!wdEnvironmentService.permissions.canChangeOrderStatus"
                    >
                      <bc-atoms-icon
                        [type]="element.status?.type"
                        [title]="element.status?.label"
                      ></bc-atoms-icon>
                    </div>

                    <!--Editable Dropdown-->
                    <div
                      *ngIf="wdEnvironmentService.permissions.canChangeOrderStatus"
                    >
                      <bc-atoms-dropdown
                        labelKey="label"
                        iconKey="type"
                        size="small"
                        [iconOnly]="true"
                        [title]="element.status?.label"
                        [requireSelection]="true"
                        [loading]="element?.isUpdatingOrder"
                        [options]="wdOrdersV2Service.orderFilters.value.orderStatuses"
                        [(model)]="element.status"
                        (modelChange)="updateOrderStatus(element)"
                      >
                      </bc-atoms-dropdown>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Production-->
              <ng-container matColumnDef="production">
                <th
                  class="date-status-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.production.description'|translate}}"
                >
                  {{'order.details.production.title'|translate}}
                </th>
                <td
                  class="date-status-column text-center editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.production.title'|translate}}"
                >
                  <!--Production Date-->
                  <div class="status-date">
                    <!--Non-Editable-->
                    <div
                      class="details-label"
                      *ngIf="!wdEnvironmentService.permissions.canChangeProductionDate"
                    >
                      {{element.production?.start?.date|date:wdEnvironmentService.datePipeFormat}}
                    </div>
                    <!--Editable Production Date-->
                    <div
                      class="details-label production-date"
                      *ngIf="wdEnvironmentService.permissions.canChangeProductionDate"
                    >
                      <div
                        [ngbPopover]="popContentDate"
                        [autoClose]="'outside'"
                        placement="bottom"
                        triggers="manual"
                        #orderDatePopover="ngbPopover"
                        (click)="toggleOrderDatePopover(orderDatePopover, element, dateTypes.production)"
                      >
                        <a target="_blank">
                          <bc-atoms-button
                            label="{{element.production?.start?.date|date:wdEnvironmentService.datePipeFormat}}"
                            title="{{element.production?.start?.date|date:wdEnvironmentService.datePipeFormat}}"
                            type="link"
                            icon="edit"
                            display="block"
                            [loading]="element.production?.isUpdatingOrder"
                          >
                          </bc-atoms-button>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!--Production Status-->
                  <div class="status-value fg-icon active">
                    <!--Icon Only-->
                    <div
                      *ngIf="!wdEnvironmentService.permissions.canChangeProductionStatus"
                    >
                      <bc-atoms-icon
                        [type]="element.production?.status?.type"
                        [title]="element.production?.status?.label"
                      >
                      </bc-atoms-icon>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Shipping-->
              <ng-container matColumnDef="shipping">
                <th
                  class="date-status-column text-center editable-cell"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.shipping.description'|translate}}"
                >
                  {{'order.details.shipping.title'|translate}}
                </th>
                <td
                  class="date-status-column text-center editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.shipping.title'|translate}}"
                >
                  <!--Shipping Date-->
                  <div class="status-date">
                    <!--Non-Editable-->
                    <div
                      class="details-label"
                      *ngIf="!wdEnvironmentService.permissions.canChangeDeliveryDate"
                    >
                      {{element.delivery?.date|date:wdEnvironmentService.datePipeFormat}}
                    </div>
                    <!--Editable Shipping Date-->
                    <div
                      class="details-label shipping-date"
                      *ngIf="wdEnvironmentService.permissions.canChangeDeliveryDate"
                    >
                      <div
                        [ngbPopover]="popContentDate"
                        [autoClose]="'outside'"
                        placement="bottom"
                        triggers="manual"
                        #orderDatePopover="ngbPopover"
                        (click)="toggleOrderDatePopover(orderDatePopover, element, dateTypes.shipping)"
                      >
                        <a target="_blank">
                          <bc-atoms-button
                            label="{{element.delivery?.date|date:wdEnvironmentService.datePipeFormat}}"
                            title="{{element.delivery?.date|date:wdEnvironmentService.datePipeFormat}}"
                            type="link"
                            icon="edit"
                            display="block"
                            [loading]="element.delivery?.isUpdatingOrder"
                          >
                          </bc-atoms-button>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="status-value fg-icon active">
                    <!--Icon Only-->
                    <div
                      *ngIf="!wdEnvironmentService.permissions.canChangeDeliveryStatus"
                    >
                      <bc-atoms-icon
                        [type]="element.delivery?.status?.type"
                        [title]="element.delivery?.status?.label"
                      >
                      </bc-atoms-icon>
                    </div>

                    <!--Editable Dropdown-->
                    <div
                      *ngIf="wdEnvironmentService.permissions.canChangeDeliveryStatus"
                    >
                      <bc-atoms-dropdown
                        labelKey="label"
                        iconKey="type"
                        size="small"
                        [iconOnly]="true"
                        [title]="element.delivery.status.label"
                        [requireSelection]="true"
                        [loading]="element.isUpdatingOrder"
                        [options]="wdOrdersV2Service.orderFilters.value.deliveryStatuses"
                        [(model)]="element.delivery.status"
                        (modelChange)="updateShippingStatus(element)"
                      >
                      </bc-atoms-dropdown>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Weight-->
              <ng-container matColumnDef="weight">
                <th
                  class="weight-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.weight.description'|translate}}"
                >
                  {{'order.details.weight.title'|translate}}
                </th>
                <td
                  class="weight-column text-center bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.weight.title'|translate}}"
                >
                  <div *ngIf="element.totals?.weight?.value > 0">
                    <!--Weight-->
                    <div class="weight-label details-label">
                      <bc-atoms-icon type="weight"></bc-atoms-icon>
                      {{'statuses.total'|translate}}
                    </div>
                    <div class="weight-value main-label">
                      {{element.totals.weight.label}}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Price-->
              <ng-container matColumnDef="price">
                <th
                  class="price-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.price.description'|translate}}"
                >
                  {{'order.details.price.title'|translate}}
                </th>
                <td
                  class="price-column text-center bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.price.title'|translate}}"
                >
                  <div *ngIf="element.totals?.price?.value > 0">
                    <!--Price-->
                    <div class="price-label details-label">
                      <bc-atoms-icon type="reimbursements"></bc-atoms-icon>
                      {{'statuses.total'|translate}}
                    </div>
                    <div class="price-value main-label">
                      {{element.totals.price.label}}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Labour-->
              <ng-container matColumnDef="labour">
                <th
                  class="labour-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.labour.description'|translate}}"
                >
                  {{'order.details.labour.title'|translate}}
                </th>
                <td
                  class="labour-column text-center bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.labour.title'|translate}}"
                >
                  <div *ngIf="element.totals?.shopLabour?.value > 0">
                    <!--Fabrication Time-->
                    <div class="fabrication-label details-label">
                      <bc-atoms-icon type="time"></bc-atoms-icon>
                      {{element.totals.shopLabour.label}}
                    </div>
                    <!--Labour Progress-->
                    <div class="progress">
                      <div
                        class="progress-bar bg-success"
                        *ngIf="element.totals.shopLabourComplete.value > 0"
                        [ngStyle]="{ width: ((element.totals.shopLabourComplete.value/element.totals.shopLabour.value) * 100) + '%' }"
                      >
                        {{element.totals.shopLabourComplete.label}}
                      </div>
                      <div
                        class="progress-bar bg-light"
                        *ngIf="element.totals.shopLabourRemain.value > 0"
                        [ngStyle]="{ width: ((element.totals.shopLabourRemain.value/element.totals.shopLabour.value) * 100) + '%' }"
                      >
                        {{element.totals.shopLabourRemain.label}}
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Items Progress-->
              <ng-container matColumnDef="progress">
                <th
                  class="progress-column text-center"
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  title="{{'order.details.progress.description'|translate}}"
                >
                  {{'order.details.progress.title'|translate}}
                </th>
                <td
                  class="progress-column text-center bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  *matCellDef="let element"
                  data-title="{{'order.details.progress.title'|translate}}"
                >
                  <div *ngIf="element.meta.items.count > 0">
                    <!--Total Items-->
                    <div
                      class="items-label details-label"
                      [title]="
                        element.meta.items.progress.count + ' ' + ('statuses.complete'|translate|lowercase) + '\n' +
                        (element.meta.items.count-element.meta.items.progress.count) + ' ' + ('statuses.remaining'|translate|lowercase) + '\n' +
                        element.meta.items.count + ' ' + ('statuses.total'|translate|lowercase)"
                    >
                      {{element.meta.items.progress.count}} /
                      {{element.meta.items.count}}
                    </div>
                    <!--Item Progress-->
                    <div
                      class="progress"
                      [title]="element.meta.items.progress.count + ' ' + ('statuses.complete'|translate|lowercase) + '\n' +
                        (element.meta.items.count-element.meta.items.progress.count) + ' ' + ('statuses.remaining'|translate|lowercase) + '\n' +
                        element.meta.items.count + ' ' + ('statuses.total'|translate|lowercase)"
                    >
                      <div
                        class="progress-bar"
                        *ngIf="element.meta.items.progress.count > 0"
                        [ngStyle]="{ width: (element.meta.items.progress.ratio * 100) + '%' }"
                        [ngClass]="{ 'bg-success': (element.meta.items.count === element.meta.items.progress.count),
                        'bg-info': (element.meta.items.count > element.meta.items.progress.count) }"
                      ></div>
                      <div
                        class="progress-bar bg-light"
                        *ngIf="element.meta.items.progress.count < element.meta.items.count"
                        [ngStyle]="{ width: (((element.meta.items.count - element.meta.items.progress.count) /
                        element.meta.items.count) * 100) + '%' }"
                      ></div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!--Options-->
              <ng-container matColumnDef="options">
                <th
                  class="action-button-column icon-button editable-cell"
                  mat-header-cell
                  *matHeaderCellDef
                ></th>
                <td
                  class="action-button-column icon-button editable-cell bcx-{{element.status?.type}}-row bcx-{{element.production.status?.type}}-row"
                  mat-cell
                  [ngClass]="{'inactive-row': element.status === 'retired'}"
                  *matCellDef="let element"
                >
                  <div class="details-label">&nbsp;</div>
                  <div class="input-container">
                    <bc-atoms-button
                      title="{{'exports.reports.title'|translate }}"
                      icon="export"
                      display="block"
                      size="small"
                      [disabled]="false"
                      [iconOnly]="true"
                    >
                      <div dropdown-content>
                        <form class="m-2">
                          <!--Reports-->
                          <bc-atoms-input-group
                            *ngIf="element?.reports?.length > 0"
                            labelIcon="all"
                            labelTitle="{{'exports.reports.title'|translate}}"
                            labelDescription="{{'exports.reports.description'|translate}}"
                          >
                            <div
                              class="dropdown-item"
                              *ngFor="let reportElem of element.reports"
                            >
                              <a
                                [href]="reportElem.url"
                                [target]="reportElem.target"
                              >
                                <bc-atoms-icon
                                  [type]="reportElem.icon"
                                ></bc-atoms-icon>
                                <label>{{reportElem.label}}</label>
                              </a>
                            </div>
                          </bc-atoms-input-group>

                          <!--Exports-->
                          <bc-atoms-input-group
                            *ngIf="element?.exports?.length > 0"
                            labelIcon="all"
                            labelTitle="{{'exports.title'|translate}}"
                            labelDescription="{{'exports.description'|translate}}"
                          >
                            <div
                              class="dropdown-item"
                              *ngFor="let exportElem of element.exports"
                            >
                              <a
                                [href]="exportElem.url"
                                [target]="exportElem.target"
                              >
                                <bc-atoms-icon
                                  [type]="exportElem.icon"
                                ></bc-atoms-icon>
                                <label>{{exportElem.label}}</label>
                              </a>
                            </div>
                          </bc-atoms-input-group>

                          <!--Downloads (CAM export, etc.)-->
                          <bc-atoms-input-group
                            *ngIf="element?.downloads?.length > 0"
                            labelIcon="all"
                            labelTitle="{{'exports.downloads.title'|translate}}"
                            labelDescription="{{'exports.downloads.description'|translate}}"
                          >
                            <div
                              class="dropdown-item"
                              *ngFor="let downloadElem of element.downloads"
                            >
                              <a
                                [href]="downloadElem.url"
                                [target]="downloadElem.target"
                              >
                                <bc-atoms-icon
                                  [type]="downloadElem.icon"
                                ></bc-atoms-icon>
                                <label>{{downloadElem.label}}</label>
                              </a>
                            </div>
                          </bc-atoms-input-group>
                        </form>
                      </div>
                    </bc-atoms-button>
                  </div>
                </td>
              </ng-container>
            </bc-templates-table-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="order-footer row mt-3">
    <div class="w-100" *ngIf="!wdOrdersV2Service.isLoadingOrders.value">
      <app-orders-list-header-component
        [orderType]="orderType"
        [orderTitle]="orderTitle"
        [orderSubtitle]="orderSubtitle"
        [showHeader]="false"
      ></app-orders-list-header-component>
    </div>
  </div>
</form>

<!--Order Content Popover-->
<ng-template #popContent let-order="order">
  <div class="order-content-popover">
    <!--Special Instructions-->
    <div class="text-value highlighted" *ngIf="order.specialInstructions">
      <bc-atoms-input-group
        labelIcon="info"
        labelTitle="{{'order.instructions.title'|translate}}"
        labelDescription="{{'order.instructions.description'|translate}}"
      >
        <div class="special-instructions-text">
          {{order.specialInstructions}}
        </div>
      </bc-atoms-input-group>
    </div>

    <!--Attachments Count-->
    <div class="text-value label-only" *ngIf="order.meta.attachments.count > 0">
      <bc-atoms-input-group
        labelIcon="attachment"
        labelTitle="{{'order.details.attachments.count'|translate: { count: order.meta.attachments.count } }}"
        labelDescription="{{'order.details.attachments.description'|translate}}"
      >
      </bc-atoms-input-group>
    </div>

    <!--Adjustments Count-->
    <div class="text-value label-only" *ngIf="order.meta.adjustments.count > 0">
      <bc-atoms-input-group
        labelIcon="adjustment"
        labelTitle="{{'order.details.adjustments.count'|translate: { count: order.meta.adjustments.count } }}"
        labelDescription="{{'order.details.adjustments.description'|translate}}"
      >
      </bc-atoms-input-group>
    </div>
  </div>
</ng-template>

<!--Manage Date Popover-->
<ng-template
  #popContentDate
  let-order="order"
  let-type="type"
  let-popover="popover"
  let-min="min"
  let-max="max"
>
  <div class="order-date-popover">
    <ngb-datepicker
      [(ngModel)]="order[type.key].dateFormatted"
      [minDate]="min"
      [maxDate]="max"
      [disabled]="order[type.key].isUpdatingOrder"
      (ngModelChange)="updateOrderDate(order, type, popover)"
    >
    </ngb-datepicker>
  </div>
</ng-template>

<!--Manage Override Popover-->
<ng-template
  #popContentOverride
  let-order="order"
  let-popover="popover"
  let-type="type"
  let-label="label"
>
  <div class="order-override-popover">
    <!--Original Value-->
    <div class="text-value">
      <bc-atoms-input-group
        labelIcon="jobsAdmin"
        labelTitle="{{'order.list.job.' + type + '.title'|translate}}"
        labelDescription="{{'order.list.job.' + type + '.description'|translate}}"
      >
        <div class="item">{{order.job[type]}}</div>
      </bc-atoms-input-group>
    </div>

    <!--Override Value-->
    <div class="input-value">
      <bc-atoms-input-group
        labelIcon="adjustment"
        labelTitle="{{'order.list.job.' + type + '.override.title'|translate}}"
        labelDescription="{{'order.list.job.' + type + '.override.description'|translate}}"
      >
        <div class="item">
          <bc-atoms-input
            id="jobOverride{{type}}_{{order.number}}"
            name="jobOverride{{type}}_{{order.number}}"
            title="{{'order.list.job.' + type + '.override.title'|translate}}"
            placeholder="{{'order.list.job.' + type + '.override.description'|translate}}"
            [disabled]="order.job?.override['isUpdating' + label]"
            [(model)]="order.job.override[type + 'Edit']"
          ></bc-atoms-input>
        </div>
      </bc-atoms-input-group>
    </div>

    <hr />

    <div class="button-options">
      <div class="button">
        <!--Cancel-->
        <bc-atoms-button
          label="{{'actions.cancel'|translate}}"
          title="{{'actions.cancel'|translate}}"
          icon="cancel"
          size="small"
          display="block"
          [disabled]="order.job?.override['isUpdating' + label]"
          (onButtonClicked)="cancelPopover(popover)"
        >
        </bc-atoms-button>
      </div>
      <div class="button">
        <!--Save-->
        <bc-atoms-button
          label="{{'actions.save'|translate}}"
          title="{{'actions.save'|translate}}"
          icon="save"
          display="block"
          size="small"
          type="success"
          [loading]="order.job?.override['isUpdating' + label]"
          [disabled]="order.job.override[type] === order.job.override[type + 'Edit']"
          (onButtonClicked)="updateOrderJobOverride(order, popover, type, label)"
        >
        </bc-atoms-button>
      </div>
    </div>
  </div>
</ng-template>
